@if (dataSource.loading) {
  <div class="spinner-container">
    <mat-spinner></mat-spinner>
  </div>
}

<mat-form-field class="pub-category">
  <mat-label>Choose Category</mat-label>
  <mat-select
    [(value)]="selectedCat"
    (selectionChange)="onSelectCategory($event)"
  >
    @for (category of categories; track category) {
      <mat-option [value]="category.value">
        {{ category.viewValue }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>

<div class="search-container">
  <mat-form-field class="search-pub">
    <mat-label>Search Product</mat-label>
    <input
      matInput
      type="text"
      [(ngModel)]="searchWord"
      (keyup.Backspace)="cancelSearch()"
      (input)="searchInputEvent($event.target.value)"
    />
  </mat-form-field>
  <button
    mat-button
    class="button-action"
    matTooltip="search"
    matTooltipClass="tooltip1"
    [disabled]="!searchWord || searchWord.length === 0"
    (click)="searchProduct()"
  >
    <mat-icon matPrefix>search</mat-icon>
  </button>
</div>

<div class="container1 mat-elevation-z8">
  <mat-table
    [dataSource]="dataSource"
    class="mat-elevation-z8"
    matSort
    matSortActive="title"
    matSortDisableClear
    matSortDirection="desc"
  >
    <ng-container matColumnDef="title">
      <mat-header-cell *matHeaderCellDef>Product Title</mat-header-cell>
      <mat-cell *matCellDef="let row; let i = index" class="title-cell">
        <span>{{ row.title }}</span>
        @if (!row.old) {
          <button
            mat-button
            (click)="expandArchive(row.acronym, row.title)"
            class="archive"
          >
            {{ row.archived == 1 ? "Archive" : "Hide" }}
          </button>
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="version">
      <mat-header-cell *matHeaderCellDef class="p-version"
        >Version</mat-header-cell
      >
      <mat-cell *matCellDef="let row" class="p-version">{{
        row.version
      }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="lastUpdate">
      <mat-header-cell *matHeaderCellDef>Date Posted</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.lastUpdate }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="pubId">
      <mat-header-cell *matHeaderCellDef
        >Release Notes<mat-icon
          class="help-info"
          (click)="openHelpInfo($event, 1)"
          >info</mat-icon
        ></mat-header-cell
      >
      <mat-cell *matCellDef="let row">
        @if (row.category == "IP" || row.category == "CAN-MEX") {
          @if (
            !["ACT", "NT", "NS", "QLD", "UAE"].includes(row.acronym) &&
            row.title.indexOf("Local") === -1
          ) {
            <a
              href="publications\IP\IP{{
                row.acronym.indexOf('|') !== -1
                  ? row.acronym.substring(0, row.acronym.indexOf('|'))
                  : row.acronym
              }}{{ row.version.toString().substring(2) }}\IP{{
                row.acronym.indexOf('|') !== -1
                  ? row.acronym.substring(0, row.acronym.indexOf('|'))
                  : row.acronym
              }}{{ row.version.toString().substring(2) }}-RN-Marketing.pdf"
              target="_blank"
              >View</a
            >
          }
        }
        @if (row.category != "IP" && row.category != "CAN-MEX") {
          @if (
            !["ERMM", "OSS", "SDEA-CA-Sum", "SDOA-CA-Sum"].includes(
              row.acronym
            ) || selected == "Archive"
          ) {
            <a
              href="publications\{{ row.category.toUpperCase() }}\{{
                row.acronym
              }}\{{ row.acronym }}-RN-Marketing.pdf"
              target="_blank"
              >View</a
            >
          }
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="formatAndPath">
      <mat-header-cell *matHeaderCellDef class="justify-end"
        >Format<mat-icon
          class="help-info"
          (click)="openHelpInfo($event, 2)"
          >info</mat-icon
        ></mat-header-cell
      >
      <mat-cell *matCellDef="let row" class="justify-end">
        <div class="dropdown-state">
          @if (hasState(row.pubId)) {
            <mat-select
              class="sd-dropdown"
              placeholder=""
              (selectionChange)="
                onSelectStatePdf(row.pubId, row.acronym, $event)
              "
            >
              @for (state of getStates(row.pubId); track state) {
                <mat-option [value]="state">
                  {{ state }}
                </mat-option>
              }
            </mat-select>
          }
          @for (item of row.formatAndPath | jsonArray; track item) {
            <button
              class="format-img"
              (click)="
                openPublication(
                  row.pubId,
                  row.version,
                  item.Format,
                  row.title,
                  item.Path,
                  row.acronym
                )
              "
            >
              <img src="/assets/images/icons/{{ item.Format }}-icon.png" />
            </button>
          }
          @if (hasState(row.pubId)) {
            <mat-select
              class="sd-dropdown excel"
              placeholder=""
              (selectionChange)="onSelectStateExcel(row.pubId, $event)"
            >
              @for (state of getStates(row.pubId); track state) {
                <mat-option [value]="state">
                  {{ state }}
                </mat-option>
              }
            </mat-select>
          }
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="disabled">
      <mat-header-cell *matHeaderCellDef class="justify-end"></mat-header-cell>
      <mat-cell *matCellDef="let row" class="justify-end"></mat-cell>
    </ng-container>
    <ng-container matColumnDef="category">
      <mat-header-cell *matHeaderCellDef class="justify-end"></mat-header-cell>
      <mat-cell *matCellDef="let row" class="justify-end"></mat-cell>
    </ng-container>

    <ng-container matColumnDef="updating">
      <mat-header-cell
        *matHeaderCellDef
        class="justify-end"
        [ngClass]="{
          hideCol: selectedCat !== 'IP' && selectedCat !== 'CAN-MEX',
        }"
        >Updating</mat-header-cell
      >
      <mat-cell
        *matCellDef="let row"
        class="justify-end"
        [ngClass]="{
          hideCol: selectedCat !== 'IP' && selectedCat !== 'CAN-MEX',
        }"
      >
        @if (row.acronym.indexOf("|") !== -1) {
          <button mat-button class="purchase" (click)="purchase(row.acronym)">
            Purchase {{ row.updating }} edition
          </button>
        }
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row
      [ngClass]="{
        'archive-row': row.disabled && row.category === 'O',
        expanded: row.acronym === expandedAcronym,
      }"
      *matRowDef="let row; columns: displayedColumns"
    >
    </mat-row>
  </mat-table>
</div>
<mat-paginator
  [length]="resultsLength"
  [pageSize]="this.pageSize"
  [pageSizeOptions]="[10, 20, 50]"
  (page)="handlePageEvent($event)"
  aria-label="Select page"
></mat-paginator>
